import type { CollectionEntry } from "./types";

/**
 * Colecciones inspiradas en series que la familia Hikarai sigue hoy (ver requirements/hikarai.md).
 * `recentRank`: número más alto = aparece primero en “Últimas colecciones”.
 */
export const collections: readonly CollectionEntry[] = [
  {
    id: "arcana-boticario",
    slug: "arcana-boticario",
    name: "Diarios de la boticaria",
    pitch: "Calma, hierbas y misterios de palacio.",
    vibeLine: "Cuando te quedaste con ganas de otro episodio de la boticaria.",
    seriesHint: "Los diarios de la boticaria",
    imageKey: "colTemple",
    href: "/catalogo.html?coleccion=arcana-boticario",
    recentRank: 4,
    featured: true,
    featuredDescription:
      "Tonos suaves, detalle fino y esa sensación de “otro tiempo” que tiene la serie. Pensamos tazas y piezas de mesa que se sientan bien en la vida real, no solo en la pantalla.",
  },
  {
    id: "ruta-mar-errante",
    slug: "ruta-mar-errante",
    name: "Ruta del mar errante",
    pitch: "Aventura, tripulación y ganas de zarpar.",
    vibeLine: "Para quien lleva años siguiendo la gran historia del sombrero de paja.",
    seriesHint: "One Piece",
    imageKey: "opOcean",
    href: "/coleccion-one-piece.html",
    recentRank: 7,
    featured: true,
    featuredDescription:
      "Es la línea que más vive en nuestra casa: risas, lagrimones y ganas de ver qué sigue. Acá van termos, tazas y cosas que aguanten el día a día, con el espíritu de ir a tu ritmo, como la tripulación.",
  },
  {
    id: "luz-guardian-lunar",
    slug: "luz-guardian-lunar",
    name: "Luz de guardián lunar",
    pitch: "Brillo, nostalgia y escenas que marcaron infancia.",
    vibeLine: "Cuando creciste viendo a la guerrera que cambiaba todo con el corazón.",
    seriesHint: "Sailor Moon",
    imageKey: "colNeonHelmet",
    href: "/catalogo.html?coleccion=luz-guardian-lunar",
    recentRank: 6,
    featured: true,
    featuredDescription:
      "Colores claros, siluetas que reconoces al instante y ese aire de “magia de verdad”. Ideal para regalar o para decorar sin que parezca un afiche genérico.",
  },
  {
    id: "sello-maldito",
    slug: "sello-maldito",
    name: "Sello maldito",
    pitch: "Oscuro, directo, con mucha personalidad.",
    vibeLine: "Si te gustan los diseños fuertes y los personajes que no se andan con vueltas.",
    seriesHint: "Jujutsu Kaisen",
    imageKey: "productShogunShirt",
    href: "/catalogo.html?coleccion=sello-maldito",
    recentRank: 8,
    featured: true,
    featuredDescription:
      "Contrastes fuertes, negros profundos y detalles que se ven bien en tela y en metal. Para quien prefiere algo con actitud antes que lo mismo de siempre.",
  },
  {
    id: "neon-distrito",
    slug: "neon-distrito",
    name: "Neón de distrito",
    pitch: "Ciudad de noche, patrullas y monstruos gigantes.",
    vibeLine: "Para fans de la acción urbana y los uniformes que ya son ícono.",
    seriesHint: "Kaiju No. 8",
    imageKey: "colCyberpunkStreet",
    href: "/catalogo.html?coleccion=neon-distrito",
    recentRank: 5,
    featured: false,
    featuredDescription: "",
  },
  {
    id: "santuario-silencio",
    slug: "santuario-silencio",
    name: "Santuario en silencio",
    pitch: "Naturaleza, quietud y un toque sobrenatural.",
    vibeLine: "Cuando te gusta el anime que respira despacio y deja imagen en la cabeza.",
    seriesHint: "Espíritus y bosque (Princesa Mononoke y afines)",
    imageKey: "craftDetail",
    href: "/catalogo.html?coleccion=santuario-silencio",
    recentRank: 2,
    featured: false,
    featuredDescription: "",
  },
  {
    id: "bitacora-piloto",
    slug: "bitacora-piloto",
    name: "Bitácora del científico",
    pitch: "Experimento, supervivencia y ganas de reconstruirlo todo.",
    vibeLine: "Si te enganchó la mezcla de ciencia, humor y corazón.",
    seriesHint: "Dr. Stone",
    imageKey: "catalogCyberShirt",
    href: "/catalogo.html?coleccion=bitacora-piloto",
    recentRank: 3,
    featured: false,
    featuredDescription: "",
  },
  {
    id: "caja-eclipsio",
    slug: "caja-eclipsio",
    name: "Caja sorpresa Eclipsio",
    pitch: "No sabes qué viene adentro, pero sabes que estará bueno.",
    vibeLine: "Mezcla de piezas de varias líneas, con algo exclusivo.",
    seriesHint: "Varias series · caja sorpresa",
    imageKey: "catalogKeychain",
    href: "/catalogo.html?coleccion=caja-eclipsio",
    recentRank: 9,
    featured: false,
    featuredDescription: "",
  },
];

export function getCollectionBySlug(slug: string): CollectionEntry | undefined {
  return collections.find((c) => c.slug === slug);
}

export function collectionsByRecent(): readonly CollectionEntry[] {
  return [...collections].sort((a, b) => b.recentRank - a.recentRank);
}

export function featuredCollections(): readonly CollectionEntry[] {
  return collections.filter((c) => c.featured);
}

export function collectionsForGrid(): readonly CollectionEntry[] {
  return [...collections].sort((a, b) => a.name.localeCompare(b.name, "es"));
}
